<div class="flex items-center justify-center h-full">
	<div class="flex md:w-2/4 mt-20 items-center justify-center text-center m-10">
		<activar-card>
			<div class="flex items-center justify-center">
				<activar-icon name="success" size="80px" class="mb-5" />
			</div>

			<h2>Gracias por confiar en nosotros</h2>

			<div class="flex flex-col gap-2 mt-5">
				<activar-button
					color="primary"
					text="Volver al inicio"
					expand="full"
					fill="out"
					routerLink="/" />

				<activar-button
					color="primary"
					text="Copiar link de pago"
					expand="full"
					(click)="copyPaymentLink()" />
			</div>
		</activar-card>
	</div>
</div>
